import { useEffect } from 'react';
import HeaderStyleTwoHom from '../Shared/HeaderStyleTwoHom';
import Footer from '../Shared/Footer';
import VolunteersBanner from '../Shared/VolunteersBanner';
import Facts from '../Shared/Facts';
import MainSlider from '../Shared/MainSlider';
import About from '../Shared/About';
// import GalleryHome from "../Shared/GalleryHome";
import VideoSection from '../Shared/VideoSection';
import CustomizedDialogs from '../Shared/CustomizedDialogs';
// import CustomizedDialogs from "../Shared/CustomizedDialogs";

const Home = () => {
  useEffect(() => {
    runJQueryScripts();
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  return (
    <>
      {/* <div className="preloader"><div className="icon"></div></div> */}
      <HeaderStyleTwoHom />
      <MainSlider />
      <Facts />
      <About />
      {/* <VideoSection /> */}
      {/* <section className='causes-section' style={{ padding: '0px 0px 0px' }}>
        <div className='auto-container'>
          <div className='sec-title centered'>
            <h2>Shariah Approval for Zakat Funds</h2>
          </div>

          <div className='row clearfix'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <p style={{ textAlign: 'center' }}>
                <img
                  className='lazy-image loaded'
                  style={{ borderRadius: 20 }}
                  src='assets/images/resource/image-spacer-for-validation.png'
                  data-src='assets/images/resource/SHARIAH-APPROVAL-FOR-ZAKAT-FUNDS-OF-SADQA-E-JARIYA-WELFARE-FOUNDATION.png'
                  alt='SHARIAH-APPROVAL-FOR-ZAKAT-FUNDS-OF-SADQA-E-JARIYA-WELFARE-FOUNDATION'
                />
                <div
                  className='link-box clearfix'
                  style={{ padding: '20px 0px 10px' }}
                >
                  <a
                    href='assets/files/Certificate for Sadqa-e-Jariya Welfare Foundation.pdf'
                    target='_blank'
                    className='theme-btn btn-style-one'
                  >
                    <span className='btn-title'>Download</span>
                  </a>
                </div>
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <section className="causes-section">
        <div className="auto-container">
          <div className="sec-title centered">
            {/* <div className='sub-title'>Our Causes</div> */}
            <h2>Our Programs</h2>
            {/* <div className='text'>Cupidatat non proident sunt</div> */}
          </div>

          <div className="row clearfix">
            <div className="cause-block col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box wow fadeInUp" data-wow-delay="0ms">
                <div className="image-box">
                  <figure className="image">
                    <a href="/free-grocery-for-widows-and-senior-citizen">
                      <img
                        className="lazy-image"
                        src="../assets/images/resource/image-spacer-for-validation.png"
                        data-src="../assets/images/resource/free-grocery-for-widows-and-senior-citizen.webp"
                        alt=""
                      />
                    </a>
                  </figure>
                </div>

                <div className="lower-content">
                  <h3>
                    <a href="/free-grocery-for-widows-and-senior-citizen">
                      Free Grocery for <br /> Widows and Senior Citizen
                    </a>
                  </h3>
                  <div className="text">
                    Our Kafalat Program supports widows and vulnerable families
                    struggling with life’s challenges...
                  </div>
                  <div className="link-box">
                    <a
                      href="/free-grocery-for-widows-and-senior-citizen"
                      className="theme-btn btn-style-two"
                    >
                      <span className="btn-title">Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="cause-block col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                <div className="image-box">
                  <figure className="image">
                    <a href="/apna-rozgar">
                      <img
                        className="lazy-image"
                        src="assets/images/resource/image-spacer-for-validation.png"
                        data-src="assets/images/resource/apna-rozgar.webp"
                        alt=""
                      />
                    </a>
                  </figure>
                </div>

                <div className="lower-content">
                  <h3>
                    <a href="/apna-rozgar">
                      Apna Rozgar <br />
                      (Small Business Setups)
                    </a>
                  </h3>
                  <div className="text">
                    Do you know how many lives you can change with your support?
                    Sadaqah Jariyah Welfare Foundation has helped countless
                    individuals...
                  </div>
                  <div className="link-box">
                    <a href="/apna-rozgar" className="theme-btn btn-style-two">
                      <span className="btn-title">Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="cause-block col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box wow fadeInUp" data-wow-delay="600ms">
                <div className="image-box">
                  <figure className="image">
                    <a href="/medical-support">
                      <img
                        className="lazy-image"
                        src="assets/images/resource/image-spacer-for-validation.png"
                        data-src="assets/images/resource/medical-support.webp"
                        alt=""
                      />
                    </a>
                  </figure>
                </div>

                <div className="lower-content">
                  <h3>
                    <a href="/medical-support">Monthly Medical Support</a>
                  </h3>
                  <div className="text">
                    Our foundation also supplies monthly medication to deserving
                    individuals to ensure they receive proper healthcare...{' '}
                  </div>
                  <div className="link-box">
                    <a
                      href="/medical-support"
                      className="theme-btn btn-style-two"
                    >
                      <span className="btn-title">Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="cause-block col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box wow fadeInUp" data-wow-delay="600ms">
                <div className="image-box">
                  <figure className="image">
                    <a href="/water-hand-pumps">
                      <img
                        className="lazy-image"
                        src="assets/images/resource/image-spacer-for-validation.png"
                        data-src="assets/images/resource/water-hand-pumps.webp"
                        alt=""
                      />
                    </a>
                  </figure>
                </div>

                <div className="lower-content">
                  <h3>
                    <a href="/water-hand-pumps">
                      Water Hand Pumps & Solar Pumps
                    </a>
                  </h3>
                  <div className="text">
                    Water is a basic necessity of life, and Sadaqah Jariyah
                    Welfare Foundation is bringing this precious resource to
                    those who have been eagerly waiting for...{' '}
                  </div>
                  <div className="link-box">
                    <a
                      href="/water-hand-pumps"
                      className="theme-btn btn-style-two"
                    >
                      <span className="btn-title">Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="cause-block col-lg-4 col-md-6 col-sm-12">
              <div className="inner-box wow fadeInUp" data-wow-delay="600ms">
                <div className="image-box">
                  <figure className="image">
                    <a href="/basic-schools">
                      <img
                        className="lazy-image"
                        src="assets/images/resource/image-spacer-for-validation.png"
                        data-src="assets/images/resource/free-education-for-child-basic-schools.webp"
                        alt=""
                      />
                    </a>
                  </figure>
                </div>

                <div className="lower-content">
                  <h3>
                    <a href="/basic-schools">
                      Free Education for Child (Basic Schools)
                    </a>
                  </h3>
                  <div className="text">
                    Our foundation always cares for the educational needs of
                    deserving students who cannot continue their education due
                    to financial difficulties...{' '}
                  </div>
                  <div className="link-box">
                    <a
                      href="/basic-schools"
                      className="theme-btn btn-style-two"
                    >
                      <span className="btn-title">Read More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <VolunteersBanner />
      {/* <GalleryHome /> */}
      <Footer />
      {/* <CustomizedDialogs /> */}
    </>
  );
};
export default Home;
